import React from 'react';
import { useHistory } from 'react-router-dom';
import CardLabelAndTitle from '../../../components/CardLabelAndTitle';
import RolesAndPermissionGuard from '../../../components/RolesAndPermissionGuard';
import StyledButton from '../../../components/StyledButton';
import SummaryDetailsCover from '../../../components/SummaryDetailsCover';
import { capitalizeEverFirstLetter } from '../../../utils/helpers';
import './RepaymentSummary.scss';
import UserDetailsCardCa from '../../../components/UserDetailsCardCa';

interface IRepaymentSummary{
  payload?:any;
}
const RepaymentSummary = ({ payload }:IRepaymentSummary) => {
  const { push } = useHistory();

  return (
    <div className="loan-summary-cover">
      {' '}
      <SummaryDetailsCover paddingBottom="0px">
        <UserDetailsCardCa
          payload={payload}
          paddingBottom="15px"
        />
        <div className="loan-summary-title-and-button-div">
          <div className="loan-summary-title">
            Repayment Summary
          </div>

          <RolesAndPermissionGuard permissionName="can-view-loan-history">
            <div className="loan-summary-button">
              <StyledButton name="View Loan History" border="none" fontSize="12px" height="40px" width="141px" backgroundColor="#5941A9" color="white" borderRadius="4px" onClick={() => push(`/customers/customer-details/${payload?.userId}/loan?page=1&search=`)} />
            </div>
          </RolesAndPermissionGuard>
        </div>
        <div className="loan-summary-amount-and-status">
          <div className="loan-summary-amount">
            <div className="loan-summary-amount-label">Loan Amount</div>
            <div className="loan-summary-amount-div">
              {
                payload?.trxAmount
              }

            </div>
          </div>
          <div className={`${payload?.status} status`}>{payload?.status && capitalizeEverFirstLetter(payload?.status)}</div>
        </div>
        <div>
          <CardLabelAndTitle
            content={payload}
            attribute={['rentAmount', 'downPayment', 'tenor', 'interest', 'moratoriumDuration']}
            label={
              {
                rentAmount: 'Rent',
                downPayment: 'Down Payment',
                tenor: 'Loan Tenor',
                interest: 'Interest Rate',
                moratoriumDuration: 'Moratorium Duration',
              }
            }
          />
          <CardLabelAndTitle
          // marginBottom="0px"
            content={payload}
            attribute={['landlord', 'landlordPhone', 'leaseStartDate', 'endDate', 'hasFirstAndLastMonthPaid']}
            label={
              {
                landlord: 'Landlord',
                landlordPhone: 'Landlord Contact',
                leaseStartDate: 'Lease start date',
                hasFirstAndLastMonthPaid: 'Has First and Last Month Paid?',
                endDate: 'End Date',
              }
            }
          />
        </div>
      </SummaryDetailsCover>

    </div>
  );
};
export default RepaymentSummary;
